import PrimeAddedDatalayer from "./PrimeAddedDatalayer";

export default PrimeAddedDatalayer;
